import React, { useState } from "react";
import { iconData } from "../../../../iconData";
import MideaViewer from "../../../../midea_viewer/MideaViewer";
import { Player } from "video-react";
import { IP } from "./../../../../internalServer";
import axios from "./../../../../axios";
import {
  Box,
  Card,
  IconButton,
  Tooltip,
  Typography,
  Dialog,
  DialogContent,
  Fade,
  Backdrop,
} from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

const AttachActivity = ({
  closeAttach,
  newActivity,
  attach,
  activityState,
  indexToRemove,
  setAttach,
  setAttachment,
  attachArr,
  attachMent,
}) => {
  const [mideaviewer, setMideaviewer] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [isError, setIsError] = useState(false);
  const [responseAttach, setResponseAttach] = useState();
  const [openDialog, setOpenDialog] = useState(false);

  let attachments = attach;

  const attachformat = (para) => {
    if (para !== undefined) {
      const filePath = para;
      const fileArr = filePath.split("/");
      const fileName = fileArr[fileArr.length - 1];
      const lastUnderscoreIndex = fileName.lastIndexOf("_");
      if (lastUnderscoreIndex !== -1) {
        return fileName.substring(lastUnderscoreIndex + 1);
      } else {
        return fileName;
      }
    }
    return "";
  };

  const closeAttachS = async (elementToRemove) => {
    const updatedAttachments = activityState?.correctAnswer?.attachment?.filter(
      (attachment) => attachment !== elementToRemove,
    );
    const updatedAttach = activityState?.attach?.filter(
      (_, index) => index !== indexToRemove,
    );

    const isLink =
      elementToRemove.startsWith("http://") ||
      elementToRemove.startsWith("https://");

    if (!isLink) {
      try {
        await axios.delete(`/api/v1/file/delete`, {
          data: { file_path: elementToRemove },
        });
      } catch (err) {
        console.error("File delete failed:", err);
      }
    }

    const newArray = [...attachArr];
    const newArrayLimit = [...attachMent];
    newArray.splice(indexToRemove, 1);
    newArrayLimit.splice(indexToRemove, 1);

    setAttachment(newArrayLimit);

    closeAttach((prevState) => ({
      ...prevState,
      attach: updatedAttach,
      correctAnswer: {
        ...prevState.correctAnswer,
        attachment: updatedAttachments,
      },
    }));
  };

  const handleClick = (attachment) => {
    setResponseAttach(attachment);
    setIsClicked(!isClicked);
    setOpenDialog(true);
  };

  const handleClickforpdf = (attachment) => {
    setResponseAttach(attachment);
    setMideaviewer(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setIsClicked(false);
    setIsError(false);
  };

  const ext = attachments.split(".").pop()?.toLowerCase() || "";
  const isImage = ["jpg", "jpeg", "png"].includes(ext);
  const isVideo = ["mp4", "mov", "wmv", "mpeg"].includes(ext);
  const isPdf = ["pdf"].includes(ext);
  const isPpt = ["ppt", "pptx"].includes(ext);
  const isLink =
    attachments.startsWith("http://") || attachments.startsWith("https://");

  const handleOpen = () => {
    if (isLink) {
      window.open(attachments, "_blank");
    } else if (isImage || isVideo) {
      handleClick(attachments);
    } else if (isPdf || isPpt) {
      handleClickforpdf(attachments);
    }
  };

  function generateLinkName(attachments) {
    if (!attachments.startsWith("https://")) {
      return "Invalid link";
    }
    const today = new Date();
    const day = String(today.getDate()).padStart(2, "0");
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const year = today.getFullYear();
    const formattedDate = `${day}-${month}-${year}`;
    return `link_${formattedDate}`;
  }

  const getAttachmentName = (attachment) => {
    if (!attachment) return "";
    if (attachment.startsWith("https://")) {
      return generateLinkName(attachment);
    }
    return attachment.split("/").pop().replace(/^\d+_/, "");
  };

  const getLinkDisplayName = (attachment) => {
    if (!attachment) return "";
    if (attachment.startsWith("http://") || attachment.startsWith("https://")) {
      try {
        const url = new URL(attachment);
        const hostname = url.hostname.replace("www.", "");
        if (hostname.includes("youtube.com") || hostname.includes("youtu.be")) {
          return "YouTube Video";
        }
        if (hostname.includes("drive.google.com")) {
          return "Google Drive";
        }
        if (hostname.includes("docs.google.com")) {
          return "Google Docs";
        }
        return (
          hostname.split(".")[0].charAt(0).toUpperCase() +
          hostname.split(".")[0].slice(1)
        );
      } catch {
        return "Web Link";
      }
    }
    return getAttachmentName(attachment);
  };

  return (
    <>
      <Card
        onClick={handleOpen}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: 2,
          py: 1.2,
          borderRadius: 2,
          boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
          backgroundColor: "#fafafa",
          cursor: "pointer",
          "&:hover": {
            boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
            backgroundColor: "#fff",
          },
          mb: 1.5,
        }}
      >
        {/* Left Section: File Icon + Info */}
        <Box display="flex" alignItems="center" gap={2}>
          <Box
            sx={{
              width: 42,
              height: 42,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#f5f5f5",
              borderRadius: 1.5,
              overflow: "hidden",
            }}
          >
            <img
              src={
                isLink
                  ? "/images/link-icon.png"
                  : iconData?.find(
                      (i) =>
                        i.extension.toLowerCase() ===
                        attachments?.split(".").pop()?.toLowerCase(),
                    )?.icon || "/images/file-default.png"
              }
              alt=""
              style={{ width: 24, height: 24, objectFit: "contain" }}
            />
          </Box>

          <Box>
            <Tooltip title={getLinkDisplayName(attachments)}>
              <Typography
                variant="body2"
                sx={{
                  color: "#555",
                  maxWidth: 120,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  cursor: "pointer",
                  fontWeight: 500,
                }}
              >
                {getLinkDisplayName(attachments)}
              </Typography>
            </Tooltip>
          </Box>
        </Box>

        {/* Right Section: Open icon + Remove */}
        <Box display="flex" alignItems="center" gap={0.5}>
          {isLink && (
            <IconButton
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                window.open(attachments, "_blank");
              }}
              sx={{ color: "#1976d2" }}
            >
              <OpenInNewIcon fontSize="small" />
            </IconButton>
          )}
          <IconButton
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              closeAttachS(attachments);
            }}
          >
            <CloseRoundedIcon sx={{ color: "#b71c1c" }} />
          </IconButton>
        </Box>
      </Card>

      {/* ═══════════════════════════════════════════════════
          MODERN FULL-SCREEN DIALOG FOR IMAGES/VIDEOS
          ═══════════════════════════════════════════════════ */}
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        maxWidth={false}
        fullScreen
        TransitionComponent={Fade}
        TransitionProps={{ timeout: 300 }}
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 300,
          sx: { backgroundColor: "rgba(0, 0, 0, 0.92)" },
        }}
        PaperProps={{
          sx: {
            backgroundColor: "transparent",
            boxShadow: "none",
            overflow: "hidden",
          },
        }}
      >
        <DialogContent
          sx={{
            p: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100vh",
            position: "relative",
          }}
        >
          {/* Close Button - Top Right */}
          <IconButton
            onClick={handleCloseDialog}
            sx={{
              position: "absolute",
              top: 20,
              right: 20,
              zIndex: 10,
              backgroundColor: "rgba(255,255,255,0.15)",
              backdropFilter: "blur(10px)",
              color: "#fff",
              width: 48,
              height: 48,
              "&:hover": {
                backgroundColor: "rgba(255,255,255,0.25)",
              },
            }}
          >
            <CloseRoundedIcon sx={{ fontSize: 28 }} />
          </IconButton>

          {/* File Name - Top Left */}
          <Typography
            variant="subtitle1"
            sx={{
              position: "absolute",
              top: 24,
              left: 24,
              zIndex: 10,
              color: "#fff",
              backgroundColor: "rgba(0,0,0,0.5)",
              px: 2,
              py: 0.5,
              borderRadius: 2,
              maxWidth: "60%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {getLinkDisplayName(responseAttach)}
          </Typography>

          {/* Content */}
          <Box
            sx={{
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              p: 4,
            }}
          >
            {!isError ? (
              <>
                {responseAttach?.split(".").pop()?.toLowerCase() === "mp4" ||
                responseAttach?.split(".").pop()?.toLowerCase() === "mov" ||
                responseAttach?.split(".").pop()?.toLowerCase() === "wmv" ? (
                  <video
                    controls
                    autoPlay
                    style={{
                      maxWidth: "90%",
                      maxHeight: "90%",
                      borderRadius: 12,
                      boxShadow: "0 20px 60px rgba(0,0,0,0.5)",
                    }}
                  >
                    <source
                      src={IP + responseAttach?.replace(/^\./, "")}
                      type="video/mp4"
                    />
                  </video>
                ) : (
                  <img
                    src={IP + responseAttach?.replace(/^\./, "")}
                    alt="Full-size"
                    onError={() => setIsError(true)}
                    style={{
                      maxWidth: "90%",
                      maxHeight: "90%",
                      objectFit: "contain",
                      borderRadius: 12,
                      boxShadow: "0 20px 60px rgba(0,0,0,0.5)",
                    }}
                  />
                )}
              </>
            ) : (
              <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                gap={2}
              >
                <img
                  src="/images/no-photo-1.png"
                  alt="Error"
                  style={{ width: 120, opacity: 0.8 }}
                />
                <Typography
                  variant="h6"
                  sx={{ color: "#fff", fontWeight: 500 }}
                >
                  Failed to load the requested file
                </Typography>
                <IconButton
                  onClick={handleCloseDialog}
                  sx={{
                    color: "#fff",
                    border: "1px solid rgba(255,255,255,0.3)",
                    borderRadius: 2,
                    px: 3,
                    py: 1,
                    "&:hover": {
                      backgroundColor: "rgba(255,255,255,0.1)",
                    },
                  }}
                >
                  <CloseRoundedIcon sx={{ mr: 1 }} />
                  Close
                </IconButton>
              </Box>
            )}
          </Box>
        </DialogContent>
      </Dialog>

      {/* PDF Viewer */}
      {mideaviewer && (
        <MideaViewer
          closeMideaviewer={setMideaviewer}
          attachment={attachments}
        />
      )}
    </>
  );
};

export default AttachActivity;
